import { Component, Input, Output, EventEmitter, SimpleChange, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import * as _ from "lodash";
import { ProductionShopFloorWorkOrders } from 'src/app/services/service/DataProviders/ProductionShopFloorWorkOrders';
import { PoTree } from './potree/po-tree';

@Component({
  selector: 'po-tree',
  templateUrl: './po-tree.component.html',
  styleUrls: ['./po-tree.component.scss'],
})
export class PoTreeComponent {

  @Input() wo: any[] = [];
  public po = null;
  public treeForView: any = [];

  constructor(private woService: ProductionShopFloorWorkOrders) { }

  ngOnChanges(sc: SimpleChange) {
    const currentValue = _.get(sc, 'wo.currentValue');
    if (!_.isNull(currentValue)) {
      this.po = currentValue;
      this.initTree();
    }
  }

  async initTree() {
    const poTree = new PoTree(this.woService);
    const masterNode = await poTree.buildTree(this.po);
    const maxLevel = await poTree.getMaxLevel();
    this.treeForView = [this.buildTreeForFE(masterNode, poTree)];

    console.log(this.treeForView)
  }

  private buildTreeForFE(node, poTree) {
    return {
      node,
      children: poTree.getSuccessors(node).map((n) => this.buildTreeForFE(
        n,
        poTree
      ))
    }
  }

  getChildrens = (node) => node.children;

}
